import { render, staticRenderFns } from "./qstDetail.vue?vue&type=template&id=19273202&scoped=true&"
import script from "./qstDetail.vue?vue&type=script&lang=js&"
export * from "./qstDetail.vue?vue&type=script&lang=js&"
import style0 from "./qstDetail.vue?vue&type=style&index=0&id=19273202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19273202",
  null
  
)

component.options.__file = "qstDetail.vue"
export default component.exports